<template>
  <div>
    <section class="segment selectCustomer pb_15" v-if="ready">
      <!-- 選擇CRM或無ID -->
      <div class="d-flex align-items-center">
        <h4 class="text-green my-0 mr-3">選擇客戶</h4>
        <a
          class="btn btn-default mx-2"
          style="line-height: 20px; height: 40px"
          @click="openCustomerPopup()"
        >
          搜尋CRM家戶
        </a>
        <strong class="mx-1">或</strong>
        <a
          class="btn btn-default mx-2"
          style="line-height: 20px; height: 40px"
          @click="changeType('noId')"
        >
          空白建議書試算
        </a>
      </div>
      <!-- 要保人 insurer -->
      <div class="selectCustomer__row mt_20 mb_5">
        <div class="selectCustomer__row__title">要保人</div>
        <!-- 姓名(FAMILY) -->
        <div
          class="selectCustomer__row__item mr_9"
          v-if="inputType === 'family'"
        >
          <span>姓名:</span>
          <div
            class="mySelect"
            :class="{ focus: insurerDropDwon }"
            tabindex="0"
            hidefocus="true"
            @blur="insurerDropDwon = false"
            @mousedown="
              insurerDropDwon = !insurerDropDwon;
              customerChangeHandler(null);
            "
          >
            <div :key="insurer.insured_name">
              {{ formatInsuredName(insurer.insured_name) }}
            </div>
            <div class="mySelect__box" v-show="insurerDropDwon">
              <div
                class="mySelect__box__item"
                v-for="member in MemberList"
                :key="member.insured_id"
                @mousedown="
                  insurer = member;
                  sameInsurer && (insured = member);
                  $forceUpdate();
                  registerHanlink();
                  changeInsurer(member);
                "
              >
                {{ formatInsuredName(member.insured_name) }}<br />
                ({{ member.insured_gender == "1" ? "男" : "女" }}，{{
                  member.insured_age
                }}歲)
              </div>
            </div>
          </div>
        </div>
        <!-- 姓名(noID) -->
        <div class="selectCustomer__row__item mr_9" v-else>
          <span>姓名:</span>
          <div class="position-relative">
            <input
              type="text"
              data-vv-name="insurer_name"
              data-vv-as="姓名"
              v-model.trim="insurer.insured_name"
              class="form-control form-control-inline"
              :class="{ 'is-invalid': errors.has(`insurer_name`) }"
              @blur="noIdShowKycText"
              style="width: 148px"
              v-validate="'required|checkNm'"
              alt="ch"
              maxlength="10"
              @input="setCustomerDataTempJSON"
              @input.stop
            />
            <div
              class="clearPosition pl_10 pt_10"
              @click="clear(insurer, 'insured_name')"
              v-if="errors.has(`insurer_name`)"
            ></div>
            <span class="waring-text">
              {{ errors.first(`insurer_name`) }}
            </span>
          </div>
        </div>
        <!-- 性別 -->
        <label class="selectCustomer__row__item">
          <span>性別:</span>
          <div class="position-relative d-flex" v-if="inputType === 'family'">
            <div class="radio radio-inline mr_7 disabled">
              <input
                type="radio"
                name="insurer-sex"
                value="1"
                id="insurer-sex-man"
                v-model="insurer.insured_gender"
                :disabled="true"
              />
              <label for="insurer-sex-man">男</label>
            </div>
            <div class="radio radio-inline disabled">
              <input
                type="radio"
                name="insurer-sex"
                value="2"
                id="insurer-sex-feman"
                v-model="insurer.insured_gender"
                :disabled="true"
              />
              <label for="insurer-sex-feman">女</label>
            </div>
            <span class="waring-text">
              {{ errors.first("insurer_sex") }}
            </span>
          </div>
          <div
            class="position-relative d-flex"
            v-else
            @change="customerChangeHandler(null)"
          >
            <div class="radio radio-inline mr_7">
              <input
                type="radio"
                name="insurer-sex"
                value="1"
                id="insurer-sex-man"
                v-model="insurer.insured_gender"
                v-validate="'required'"
                data-vv-name="insurer_sex"
                data-vv-as="性別"
              />
              <label for="insurer-sex-man">男</label>
            </div>
            <div class="radio radio-inline">
              <input
                type="radio"
                name="insurer-sex"
                value="2"
                id="insurer-sex-feman"
                v-model="insurer.insured_gender"
                v-validate="'required'"
                data-vv-name="insurer_sex"
                data-vv-as="性別"
              />
              <label for="insurer-sex-feman">女</label>
            </div>
            <span class="waring-text">
              {{ errors.first("insurer_sex") }}
            </span>
          </div>
        </label>
        <!-- 生日 -->
        <div
          class="selectCustomer__row__item mr_4"
          @click="inputType == 'noId' ? customerChangeHandler(null) : () => {}"
        >
          <span>生日:</span>
          <!-- v-model="insurer.birthday" -->

          <!-- @input="birthdayChecker($event, insurer, 'insurer_age')"
            :value="
              birthdayFormatForDatePick(
                insurer.insured_birthday,
                'insurer_dataPicker'
              )
            " -->
          <div class="position-relative">
            <MfDatePicker
              v-if="inputType === 'noId'"
              :format="dateFormatter"
              :language="dateLang"
              :first-day-of-week="1"
              :typeable="true"
              @clearAll="clearBirthday('insurer')"
              @input="birthdayInputHandler($event, insurer, 'insurer_age')"
              :value="
                birthdayFormatForDatePick(
                  insurer.insured_birthday,
                  'insurer_dataPicker',
                )
              "
              :disabled="inputType === 'family'"
              :class="{
                'is-invalid':
                  insurer.birthdayError || errors.has(`insurer_age`),
              }"
              v-validate="{ required: !insurer.insured_age }"
              data-vv-name="insurer_age"
              data-vv-as="生日或年齡"
              ref="insurer_dataPicker"
              :key="`${insurer.insured_birthday}__insurer_dataPicker`"
              placeholder="YY/MM/DD"
            />
            <input
              type="text"
              :disabled="true"
              :value="birthdayFormat(insurer.insured_birthday)"
              v-else
              class="form-control form-control-inline"
              style="width: 150px"
            />
            <div
              class="clearBirthday text-green"
              v-show="inputType === 'noId' && insurer.insured_birthday"
              @click.stop="
                clearBirthday('insurer');
                $validator.reset();
              "
            >
              清除
            </div>
            <span class="waring-text"> {{ errors.first(`insurer_age`) }} </span>
          </div>
        </div>
        <!-- 年齡 -->
        <div
          class="selectCustomer__row__item"
          @click="inputType == 'noId' ? customerChangeHandler(null) : () => {}"
        >
          <span>或年齡:</span>
          <input
            type="text"
            maxlength="3"
            v-model.trim="insurer.insured_age"
            @input="ageHandler(insurer)"
            class="form-control form-control-inline"
            style="width: 66px"
            :disabled="inputType === 'family' || !!insurer.insured_birthday"
            :class="{
              'is-invalid': errors.has(`insurer_age`),
            }"
            v-validate="{ required: !insurer.insured_birthday }"
            data-vv-name="insurer_age"
            data-vv-as="生日或年齡"
            @change="customerChangeHandler(null)"
          />
        </div>
        <span class="selectCustomer__row__notify"> {{ insurer.notify }}</span>
      </div>
      <div class="d-flex">
        <div class="checkbox checkbox-inline sameInsurerCheckbox">
          <input
            type="checkbox"
            id="sameInsurer"
            v-model="sameInsurer"
            @change="sameInsurerHandler()"
            :disabled="
              !insurer.insured_name ||
              !insurer.insured_gender ||
              !(insurer.insured_age || insurer.insured_birthday)
            "
          />
          <label for="sameInsurer">同要保人</label>
        </div>
        <!-- 要保人kyc風險屬性 -->
        <div v-show="insurerKycMsg.isShow && !this.$store.getters.IsBankUser">
          <a
            style="cursor: pointer"
            @click="openRiskAttributesModal"
            class="insurer_message"
            >{{ insurerKycMsg.text !== "" ? insurerKycMsg.text : kycText }}</a
          >
        </div>
        <div v-show="insurerKycMsg.isShow && this.$store.getters.IsBankUser">
          <div
            style="cursor: pointer; text-decoration: none"
            class="insurer_message"
          >
            {{ insurerKycMsg.text !== "" ? insurerKycMsg.text : kycText }}
          </div>
        </div>
      </div>
      <!-- 被保人 insured -->
      <div class="selectCustomer__row">
        <div class="selectCustomer__row__title">主約被保險人</div>
        <!-- 姓名(FAMILY) -->
        <div
          class="selectCustomer__row__item mr_9"
          v-if="inputType === 'family'"
        >
          <span>姓名:</span>
          <div
            class="mySelect"
            :class="{ disabled: sameInsurer, focus: insuredDropDwon }"
            @mousedown="
              insuredDropDwon = !insuredDropDwon;
              customerChangeHandler(null);
            "
            tabindex="1"
            hidefocus="true"
            @blur="insuredDropDwon = false"
          >
            <div :key="insured.insured_name">
              {{ formatInsuredName(insured.insured_name) }}
            </div>
            <div class="mySelect__box" v-show="insuredDropDwon">
              <div
                class="mySelect__box__item"
                v-for="member in MemberList"
                :key="member.insured_id"
                @mousedown="
                  insured = member;
                  $forceUpdate();
                  registerHanlink();
                "
              >
                {{ formatInsuredName(member.insured_name) }}<br />
                ({{ member.insured_gender == "1" ? "男" : "女" }}，{{
                  member.insured_age
                }}歲)
              </div>
            </div>
          </div>
        </div>
        <!-- 姓名(noID) -->
        <div class="selectCustomer__row__item mr_9" v-else>
          <span>姓名:</span>
          <div class="position-relative">
            <input
              type="text"
              data-vv-name="insured_name"
              data-vv-as="姓名"
              v-model.trim="insured.insured_name"
              class="form-control form-control-inline"
              :class="{ 'is-invalid': errors.has(`insured_name`) }"
              style="width: 148px"
              v-validate="'required|checkNm'"
              :disabled="sameInsurer"
              alt="ch"
              maxlength="10"
              @input="setCustomerDataTempJSON"
              @input.stop
            />
            <div
              class="clearPosition pl_10 pt_10"
              @click="clear(insured, 'insured_name')"
              v-if="errors.has(`insured_name`)"
            ></div>
            <span class="waring-text">
              {{ errors.first(`insured_name`) }}
            </span>
          </div>
        </div>
        <!-- 性別 -->
        <label class="selectCustomer__row__item">
          <span>性別:</span>
          <div class="position-relative d-flex" v-if="inputType === 'family'">
            <div class="radio radio-inline mr_7 disabled">
              <input
                type="radio"
                name="insured-sex"
                value="1"
                id="insured-sex-man"
                v-model="insured.insured_gender"
                :disabled="true"
              />
              <label for="insured-sex-man">男</label>
            </div>
            <div class="radio radio-inline disabled">
              <input
                type="radio"
                name="insured-sex"
                value="2"
                id="insured-sex-feman"
                v-model="insured.insured_gender"
                :disabled="true"
              />
              <label for="insured-sex-feman">女</label>
            </div>
            <span class="waring-text">
              {{ errors.first("insured_sex") }}
            </span>
          </div>
          <div
            class="position-relative d-flex"
            v-else
            @change="customerChangeHandler(null)"
          >
            <div
              class="radio radio-inline mr_7"
              :class="{ disabled: sameInsurer }"
            >
              <input
                type="radio"
                name="insured-sex"
                value="1"
                id="insured-sex-man"
                v-model="insured.insured_gender"
                v-validate="'required'"
                data-vv-name="insured_sex"
                data-vv-as="性別"
              />
              <label for="insured-sex-man">男</label>
            </div>
            <div class="radio radio-inline" :class="{ disabled: sameInsurer }">
              <input
                type="radio"
                name="insured-sex"
                value="2"
                id="insured-sex-feman"
                v-model="insured.insured_gender"
                v-validate="'required'"
                data-vv-name="insured_sex"
                data-vv-as="性別"
              />
              <label for="insured-sex-feman">女</label>
            </div>
            <span class="waring-text">
              {{ errors.first("insured_sex") }}
            </span>
          </div>
        </label>
        <!-- 生日 -->
        <div
          class="selectCustomer__row__item mr_4"
          @click.passive="
            inputType == 'noId' && !sameInsurer
              ? customerChangeHandler(null)
              : () => {}
          "
        >
          <span>生日:</span>
          <div class="position-relative">
            <MfDatePicker
              v-if="inputType == 'noId'"
              :format="dateFormatter"
              :language="dateLang"
              :first-day-of-week="1"
              :typeable="true"
              @input="birthdayInputHandler($event, insured, 'insured_age')"
              :value="
                birthdayFormatForDatePick(
                  insured.insured_birthday,
                  'insured_dataPicker',
                )
              "
              @clearAll="clearBirthday('insured')"
              :disabled="inputType === 'family' || sameInsurer"
              :class="{
                'is-invalid':
                  insured.birthdayError || errors.has(`insured_age`),
              }"
              v-validate="{ required: !insured.insured_age }"
              data-vv-name="insured_age"
              data-vv-as="生日或年齡"
              ref="insured_dataPicker"
              :key="`${insured.insured_birthday}__insured_dataPicker`"
              placeholder="YY/MM/DD"
            />
            <input
              type="text"
              :disabled="true"
              :value="birthdayFormat(insured.insured_birthday)"
              v-else
              class="form-control form-control-inline"
              style="width: 150px"
            />

            <!-- v-show="insured.birthday" -->
            <div
              class="clearBirthday text-green"
              v-show="
                inputType === 'noId' && insured.insured_birthday && !sameInsurer
              "
              @click.stop="clearBirthday('insured')"
            >
              清除
            </div>
            <span class="waring-text"> {{ errors.first(`insured_age`) }} </span>
          </div>
        </div>
        <!-- 年齡 -->
        <label
          class="selectCustomer__row__item"
          @click="
            inputType == 'noId' && !sameInsurer
              ? customerChangeHandler(null)
              : () => {}
          "
        >
          <span>或年齡:</span>
          <input
            type="text"
            v-model.trim="insured.insured_age"
            @input="ageHandler(insured)"
            class="form-control form-control-inline"
            style="width: 66px"
            :disabled="
              inputType === 'family' ||
              sameInsurer ||
              !!insured.insured_birthday
            "
            :class="{
              'is-invalid': errors.has(`insured_age`),
            }"
            maxlength="3"
            v-validate="{ required: !insured.insured_birthday }"
            data-vv-name="insured_age"
            data-vv-as="生日或年齡"
            @change="customerChangeHandler(null)"
          />
        </label>
        <span class="selectCustomer__row__notify"> {{ insured.notify }}</span>
      </div>
      <div class="d-flex">
        <!-- FitBack健康吧會員等級 -->
        <div class="mt_5" v-show="inputType === 'family'">
          <a
            class="insured_message"
            :class="{ 'insured_message--disabled': isNoId(insured.insured_id) }"
            @click="openFitBackModal"
          >
            FitBack 健康吧會員等級：{{ fitBackLevelNm }}
          </a>
        </div>
      </div>
      <CustomerPopup
        :open="customerPopupOpen"
        @close="customerPopupOpen = false"
        @importList="importList($event)"
        @riskObjList="selectList"
      />

      <div
        v-if="this.$store.getters.BuTest"
        @click.prevent="checkFamily(`recommand`)"
        class="btn btn-default btn-lg oldVersionBtn"
      >
        投資型回舊建議書
      </div>
    </section>
    <!-- 投資風險屬性說明視窗 -->
    <risk-attributes-modal
      :open="riskAttributesModalOpen"
      :kyc_lvl_name="lvl_chi"
      :enableKYCPrint="enableKYCPrint"
      :custId="inputType === 'noId' ? '' : insurer.csidno"
      :custBirth="insurer.birthday"
      @close="panelClose('riskAttributesModalOpen')"
    />
    <!-- FitBack健康吧視窗 -->
    <fit-back-modal
      :open="fitBackModalOpen"
      :custId="inputType === 'family' ? insured.csidno : ''"
      @close="panelClose('fitBackModalOpen')"
    />
  </div>
</template>

<script>
//  is-invalid
import { mapGetters } from "vuex";
import { Validator } from "vee-validate";
// import { data as MemberList } from "@/desktop/views/mf/mock/memberList.json";
import MfDatePicker from "@/desktop/views/mf/plugin/DatePicker/components/Datepicker.vue";
import CustomerPopup from "./CustomerPopup.vue";
import RiskAttributesModal from "@/desktop/components/RiskAttributesModal";
import FitBackModal from "@/desktop/views/mf/components/FitBackModal";
import { getRisk_Attributes } from "@/service";
import _ from "lodash";
import mf_Mixin from "@/desktop/views/mf/mixin";
import { commonMixin } from "@/mixins/common";
import { computeAge } from "@/service";

Validator.extend("checkNm", {
  getMessage: "姓名不能有特殊符號",
  validate: (value) => {
    let pattern = /[<>!@#$^&,."'?%*()+/{}[\]\\|~`=\s]/g;
    let isNonEmpty = value.trim().length > 0;
    let isFormatCurrect = value.match(pattern) == null;
    return isNonEmpty && isFormatCurrect;
  },
});

export default {
  mixins: [mf_Mixin, commonMixin],
  components: { MfDatePicker, CustomerPopup, RiskAttributesModal, FitBackModal },
  data() {
    return {
      insurerDropDwon: false,
      insuredDropDwon: false,
      customerPopupOpen: false,
      ready: false,
      initRiskData: {},
      selectedId: "", // 目前要保人ID
      insurerKycMsg: {
        //顯示要保人風險屬性
        isShow: false,
        text: "",
      },
      riskAttributesModalOpen: false,
      fitBackModalOpen: false,
      fitBackLevelNm: "",
      lvl_chi: "", //KYC代碼中文類型
      enableKYCPrint: true, //聲明書列印按鈕是否啟用
      // 要保人同步被保人時使用，避免 insured watcher 把同步動作當成手動修改。
      syncingInsuredFromInsurer: false,
      // 清除商品確認彈窗是否已開啟，避免同一次 click/change 連續觸發兩個彈窗。
      customerChangeNoticeOpen: false,
      // 取消清除時會用快照還原客戶資料，還原期間不再觸發清除確認。
      restoringCustomerData: false,
      // 若後續內層事件才帶 callback，先暫存給「確定清除」後執行。
      pendingCustomerChangeCallback: null,
    };
  },
  computed: {
    ...mapGetters(["CustInfo"]),
    MemberList() {
      return this.$store.getters.MemberList;
    },
    memberRiskObjList() {
      return this.$store.getters.allRiskObj;
    },
    kycText() {
      return this.insurerRiskWarnText(
        this.memberRiskObjList[this.insurer.insured_id],
      );
    },
    inputType: {
      get() {
        return this.$store.getters.MfEditing.inputType;
      },
      set(val) {
        this.$store.commit("update_MfEditing", {
          inputType: val,
        });
      },
    },
    sameInsurer: {
      get() {
        return this.$store.getters.MfEditing.sameInsurer;
      },
      set(val) {
        this.$store.commit("update_MfEditing", {
          sameInsurer: val,
        });
      },
    },
    insurer: {
      get() {
        return (
          this.$store.getters.MfEditing.insurer || {
            insured_id: "",
          }
        );
      },
      set(val) {
        this.$emit("update:insurer", val);
      },
    },
    insured: {
      get() {
        return (
          this.$store.getters.MfEditing.insured || {
            insured_id: "",
          }
        );
      },
      set(val) {
        this.$emit("update:insured", val);
      },
    },
  },
  created() {
    this.init();
    this.changeTab();
    this.crmCustomerKyc();

    this.$nextTick(() => {
      if (this.insurer.insured_birthday) {
        this.updateInsuranceAging(this.insurer);
      }
      if (this.insured.insured_birthday) {
        this.updateInsuranceAging(this.insured);
      }
    });
  },
  methods: {
    //姓名長度大於6時僅顯示前6字+...
    formatInsuredName(name) {
      if (!name) {
        return "";
      }
      return name.length > 6 ? name.substring(0, 6) + "..." : name;
    },
    crmCustomerKyc() {
      if (
        (this.insurer.insured_id !== "" &&
          this.insurer.insured_id === localStorage.CustID) ||
        (this.insurer.insured_id !== "" &&
          this.insurer.insured_id === localStorage.SerNo)
      ) {
        if (
          (this.CustInfo.ID && localStorage.CustID) ||
          (this.CustInfo.serNo && localStorage.SerNo)
        ) {
          // 判斷 CRM 客戶ID
          let APC_IDList = [];
          this.MemberList.filter((item) => {
            let obj = {
              APC_ID: item.csidno,
              BRDY: item.birthday,
            };
            APC_IDList.push(obj);
          });
          this.$store.commit("set_allRiskObj", ""); //舊有家戶 riskObj 清空
          this.$mfAPI
            .MFA1_0100__getKYCInfo({
              APC_IDs: APC_IDList,
            })
            .then((res) => {
              this.$store.commit("set_allRiskObj", res);
              const riskObj = res[this.insurer.insured_id];
              this.$store.commit("set_kycRiskObj", riskObj);

              return this.insurerRiskWarnText(riskObj); //要保人 KYC風險屬性提示文字
            })
            .catch((error) => {
              this.$toast.info({
                title: "風險屬性檢核異常，您可以稍後再重新確認",
              });
            });
        }
      }
    },
    changeInsurer(member) {
      // change 要保人
      this.selectedMemberId(member);
    },
    // 客戶資料異動時，有商品先詢問是否清除；確認才清商品並執行 callback，取消則還原快照。
    customerChangeHandler(callback = null) {
      if (this.restoringCustomerData) return;
      if (this.$store.getters.MfEditing.mc_prod_list.length > 0) {
        if (callback) this.pendingCustomerChangeCallback = callback;
        if (this.customerChangeNoticeOpen) return;
        this.customerChangeNoticeOpen = true;
        this.$mfNotice(
          "重新選擇/修改客戶資料，已選商品將全部清除是否仍要重新選擇/修改客戶資料?",
          () => {
            const pendingCallback = this.pendingCustomerChangeCallback;
            this.customerChangeNoticeOpen = false;
            this.pendingCustomerChangeCallback = null;
            this.$store.commit("update_MfEditing", {
              mc_prod_list: [],
              prod_idx: "",
            });
            pendingCallback && pendingCallback();
          },
          true,
          () => {
            this.customerChangeNoticeOpen = false;
            this.pendingCustomerChangeCallback = null;
            this.restoreCustomerDataTemp();
          },
          "確定清除",
        );
      } else {
        callback && callback();
      }
    },
    openCustomerPopup() {
      this.customerChangeHandler(() => {
        this.customerPopupOpen = true;
      });
    },
    // 直接輸入生日時，需等年齡 API 回填後再計算增齡提醒。
    async birthdayInputHandler($event, customer, errorName) {
      const birthdayUpdated = await this.birthdayChecker(
        $event,
        customer,
        errorName,
      );
      if (birthdayUpdated) {
        await this.updateInsuranceAging(customer);
      }
    },
    birthdayFormat(string) {
      if (!string || string == "") {
        return "";
      }
      let stringArray = string.split("-");
      return `${stringArray[0] - 1911}/${stringArray[1]}/${stringArray[2]}`;
    },
    init() {
      this.ready = true;
      this.noIdShowKycText(); // 已完成空白建議書建議書，要秀kyc風險屬性文字
    },
    changeTab() {
      this.memberRiskObjList; // 切換Tab動作，觸發 computed 計算屬性
      this.selectedMemberId(this.insurer); //切換Tab動作，要保人沒有更動
    },
    //檢查輸入年紀
    ageHandler(target) {
      if (target.insured_age) {
        target.insured_age = target.insured_age.replace(/[^\d]/g, "");
      }
      target.insured_birthday = "";
      target.birthdayError = false;
    },
    changeType(mode) {
      switch (mode) {
        case "noId":
          this.insurerKycMsg.isShow = false; //切換空白建議書時，把要保人風險屬性清除
          this.customerChangeHandler(() => {
            this.$validator.reset();
            this.inputType = "noId";
            // this.$store.commit("set_MemberList", []);
            this.$store.commit("reset_Customer");
            this.$toast.info({
              title: "要被保人欄位資料已清除! 請重新搜尋或直接輸入!",
            });
            this.insurer = {
              insured_id: "",
            };
            this.insured = {
              insured_id: "",
            };
            this.sameInsurer = false;
            this.$emit("closeScNotice");
          });
          break;
        case "family":
          break;
        default:
          return;
      }
    },
    sameInsurerHandler() {
      if (this.sameInsurer) {
        this.insured = this.insurer;
        this.insuredDropDwon = false;
        this.$validator.reset();
        this.setCustomerDataTempJSON();
      } else {
        this.insured = _.cloneDeep(this.insurer);
      }
    },
    //匯入家戶
    importList($event) {
      this.customerPopupOpen = false;
      this.inputType = "family";
      this.insurer = _.cloneDeep($event[0]);
      this.insured = _.cloneDeep($event[0]);
      this.sameInsurer = false;
      this.$emit("closeScNotice");
      this.$store.commit("set_MemberList", $event);
      this.registerHanlink();
      const initUserId = _.cloneDeep($event[0]);
      if (initUserId) {
        this.selectedMemberId(initUserId); // 匯入家戶一開始要保人的風險屬性
      }
    },
    //檢核
    async validatorHandler() {
      const checkResult = await this.$validator.validateAll();
      if (!checkResult) {
        this.$toast.info({ title: "請檢視必填欄位是否漏填或填寫內容有誤!" });
      }
      return checkResult;
    },
    clear(target, keyName) {
      target[keyName] = "";
      this.$forceUpdate();
    },
    checkFamily(url) {
      this.$mfNotice(
        "請注意! 新舊建議書系統彼此獨立，無法資料同步!",
        () => {
          setTimeout(() => {
            // 此處照搬保健的邏輯
            const checkRegex = /\/detail\//;
            const checkInsuranceRegex = /\/insurance-check/;
            const checkRecommandRegex = /\/recommand/;
            localStorage.fromMv = "Y";
            if (checkRegex.test(window.location.href)) {
              let store = this.$store.state.custInfo;
              if (
                (store.ID == "" || store.ID == undefined) &&
                (store.serNo == "" || store.serNo == undefined)
              ) {
                this.$router.push({ path: `/${url}` });
              } else {
                this.nextTargetUrl = url;
                this.panelOpen("RecommandModalOpen");
              }
            } else if (
              checkInsuranceRegex.test(window.location.href) &&
              url === `recommand`
            ) {
              this.$router.push({ name: url, params: { checkCust: true } });
            } else {
              this.$router.push({ path: `/${url}` });
            }
          }, 200);
        },
        false,
        null,
        "確定",
        "「返回舊建議書」後建立的建議書，將無法從新建議書系統中進行列印報表等操作!",
      );
    },
    //取得投資風險屬性API，判斷是否開啟 聲明書列印 Button
    getRiskData(id, birthday) {
      getRisk_Attributes(id, "", birthday).then((result) => {
        if (result.header && result.header.status === "200") {
          this.lvl_chi = result.body.lvl_chi;
          this.kyc_lvl = result.body.kyc_lvl;
          this.eft = result.body.eft;
          this.is_empty = result.body.is_empty;
          if (this.is_empty == "Y") {
            this.enableKYCPrint = false;
          } else if (this.eft == "02") {
            this.enableKYCPrint = false;
          } else {
            if (this.kyc_lvl == "0" || this.kyc_lvl == "") {
              this.enableKYCPrint = false;
            } else {
              this.enableKYCPrint = false;
            }
          }
        } else {
          this.enableKYCPrint = false;
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢投資風險屬性失敗,請重新操作" });
          }
        }
      });
    },
    // 一開始【確定匯入】所有家族 kyc 資料
    selectList(val) {
      this.initRiskData = val;
      this.$store.commit("set_kycRiskObj", this.initRiskData[this.selectedId]);
      this.insurerRiskWarnText(this.initRiskData[this.selectedId]); //要保人 KYC風險屬性提示文字
    },
    selectedMemberId(newValue) {
      this.selectedId = newValue.insured_id;
      if (this.selectedId) {
        //變更要保人, 所有人 riskObj 用 this.memberRiskObjList
        this.$store.commit(
          "set_kycRiskObj",
          this.memberRiskObjList[this.selectedId],
        );
        this.getRiskData(this.selectedId, newValue.insured_birthday); //投資風險屬性POP
        this.insurerRiskWarnText(this.memberRiskObjList[this.selectedId]); //要保人 KYC風險屬性提示文字
      }
    },
    //要保人 KYC風險屬性提示文字 kyc_insurer_message
    insurerRiskWarnText(riskObj) {
      this.insurerKycMsg.isShow = false;
      if (riskObj !== undefined) {
        if (riskObj.hasOwnProperty("kyc_insurer_message")) {
          this.insurerKycMsg.isShow = true;
          return (this.insurerKycMsg.text = riskObj.kyc_insurer_message);
        } else {
          this.insurerKycMsg.isShow = false;
        }
      }
    },
    //開啟投資風險屬性說明視窗
    openRiskAttributesModal() {
      this.panelOpen("riskAttributesModalOpen");
    },
    isNoId(insuredId) {
      return !insuredId || insuredId.startsWith("~");
    },
    // 判斷 FitBack 健康吧會員等級顯示及是否查詢 API
    handleFitBackLevel(insured) {
      const insuredId = insured ? insured.insured_id : "";
      const insuredAge = insured ? insured.insured_age : "";

      // 無 ID 或 ID 以 ~ 開頭
      if (this.isNoId(insuredId)) {
        this.fitBackLevelNm = "待確認";
        return;
      }
      // 未滿 18 足歲
      if (insuredAge !== "" && insuredAge != null && Number(insuredAge) < 18) {
        this.fitBackLevelNm = "未滿18足歲";
        return;
      }
      // 有效 ID + 滿 18 歲
      this.getFitBackLevel(insuredId);
    },
    // 取得主約被保險人 FitBack 健康吧會員等級
    async getFitBackLevel(insured_id) {
      this.fitBackLevelNm = "";

      try {
        const { level_nm } =
          await this.$mfAPI.MFA0_1000__getMemberExperience({
            memberId: insured_id,
          });
        this.fitBackLevelNm = level_nm || "";
      } catch (error) {
        console.error(error);
      }
    },
    //開啟 FitBack健康吧視窗
    openFitBackModal() {
      this.panelOpen("fitBackModalOpen");
    },
    // 空白建議書系列-> 當輸入完要保人姓名，顯示kyc風險屬性文字
    noIdShowKycText() {
      if (
        this.insurer.insured_name !== undefined &&
        this.insurer.insured_name !== ""
      ) {
        this.insurerKycMsg.isShow = true;
        this.insurerKycMsg.text = "客戶投資風險屬性(KYC)：無";
      }
    },
    //計算客戶是否會在90天內增齡
    getDaysToAddInsuranceAge(birthday, currentInsuranceAge) {
      // 計算下次增齡日 = 生日 + 6 個月
      const nextInsuranceAgeDate = new Date(birthday);
      nextInsuranceAgeDate.setFullYear(
        nextInsuranceAgeDate.getFullYear() + currentInsuranceAge,
      );
      nextInsuranceAgeDate.setMonth(nextInsuranceAgeDate.getMonth() + 6);
      nextInsuranceAgeDate.setDate(nextInsuranceAgeDate.getDate() + 1);
      nextInsuranceAgeDate.setHours(0, 0, 0, 0);

      // 計算天數差
      const today = new Date();
      const diffTime = nextInsuranceAgeDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // 如果在 1-90 天內，返回天數；否則返回 -999
      return diffDays >= 1 && diffDays <= 90 ? diffDays : -999;
    },
    //增齡提示訊息
    async updateInsuranceAging(customer) {
      const birthday = customer.insured_birthday || customer.birthday || "";
      const actage = Number(customer.insured_age);
      if (actage == null && birthday) {
        const res = await computeAge(this.$store.state.userInfo.id, birthday);
        this.$set(customer, "insured_age", res.body.age);
      }

      //確認年齡計算完成後再計算增齡

      const days = this.getDaysToAddInsuranceAge(
        birthday,
        customer.insured_age ? Number(customer.insured_age) : 0,
      );

      if (days !== -999) {
        this.$set(customer, "notify", `再過 ${days} 天，保險年齡 +1 歲喔!`);
      } else {
        this.$set(customer, "notify", "");
      }
    },
    // 還原客戶資料
    restoreCustomerDataTemp() {
      const customerDataTemp = JSON.parse(
        this.$store.state.mf.customerDataTempJSON || "{}",
      );
      this.restoringCustomerData = true;
      this.$store.commit("update_MfEditing", customerDataTemp);
      this.$nextTick(async () => {
        try {
          await this.refreshInsuranceAgingNotify();
          this.notifyCustomerChange();
        } finally {
          this.restoringCustomerData = false;
        }
      });
    },
    // 取消清除會還原客戶快照；快照可能早於增齡提醒計算，所以還原後需重新整理提醒文字。
    async refreshInsuranceAgingNotify() {
      if (this.insurer) {
        await this.updateInsuranceAging(this.insurer);
      }
      if (!this.sameInsurer && this.insured) {
        await this.updateInsuranceAging(this.insured);
      }
    },
    // 建立清除商品彈窗按取消時可還原的客戶資料快照。
    setCustomerDataTempJSON() {
      this.$store.commit("set_customerDataTempJSON");
    },
    // 通知父層重新比對個資聲明所需的客戶資料異動狀態。
    notifyCustomerChange() {
      this.$emit("customer-change");
    },
  },
  watch: {
    insurer: {
      deep: true,
      handler(newValue) {
        this.notifyCustomerChange();
        this.$emit("update:insurer", newValue);
        if (this.sameInsurer) {
          this.syncingInsuredFromInsurer = true;
          this.insured = newValue;
          this.$nextTick(() => (this.syncingInsuredFromInsurer = false));
        }
      },
    },
    insured: {
      deep: true,
      handler(val, oldVal) {
        // 只有家戶，而且是整個被保險人換掉時才重新判斷 FitBack
        if (this.inputType === "family" && val !== oldVal) {
          this.handleFitBackLevel(val);
        }
        if (this.syncingInsuredFromInsurer) return;
        this.notifyCustomerChange();
        this.$emit("update:insured", val);
      },
      immediate: true,
    },
    inputType(val) {
      this.sameInsurer = false;
      this.insurer = _.cloneDeep(this.insurer);
      this.insured = _.cloneDeep(this.insured);
      this.$store.commit("update_MfEditing", {
        inputType: val,
      });
    },
    "insurer.insured_name": function (val) {
      if (val == "") {
        this.sameInsurer = false;
        this.registerHanlink();
        this.$forceUpdate();
        this.insurerKycMsg.isShow = false;
      }
    },
    "insured.insured_name": function (val) {
      this.registerHanlink();
      this.$forceUpdate();
    },
    "insurer.insured_birthday": function (val) {
      if (val) this.updateInsuranceAging(this.insurer);
      if (!this.sameInsurer && val == "" && this.insurer.insured_age == "") {
        this.sameInsurer = false;
        this.insurer = _.cloneDeep(this.insurer);
        this.insured = _.cloneDeep(this.insured);
      }
    },
    "insurer.birthday"(val) {
      if (val) this.updateInsuranceAging(this.insurer);
    },

    "insurer.insured_age": function (val) {
      if (
        !this.sameInsurer &&
        val == "" &&
        this.insurer.insured_birthday == ""
      ) {
        this.sameInsurer = false;
        this.insurer = _.cloneDeep(this.insurer);
        this.insured = _.cloneDeep(this.insured);
      }
    },
    "insured.insured_gender"(newVal, oldVal) {
      //因為同要保人打勾後的被保人資料變更不會觸發onChange事件，這裡處理同要保人打勾時資料變更觸發customerChangeHandler
      if (newVal !== oldVal && this.sameInsurer) {
        this.customerChangeHandler(null);
      }
    },
    "insured.insured_age"(newVal, oldVal) {
      //因為同要保人打勾後的被保人資料變更不會觸發onChange事件，這裡處理同要保人打勾時資料變更觸發customerChangeHandler
      if (newVal !== oldVal && this.sameInsurer) {
        this.customerChangeHandler(null);
      }
    },
    "insured.insured_birthday"(newVal, oldVal) {
      if (newVal) this.updateInsuranceAging(this.insured);
      //因為同要保人打勾後的被保人資料變更不會觸發onChange事件，這裡處理同要保人打勾時資料變更觸發customerChangeHandler
      if (newVal !== oldVal && this.sameInsurer) {
        this.customerChangeHandler(null);
      }
    },
  },
};
</script>

<style lang="scss">
.paragraph {
  white-space: none;
}
.selectCustomer {
  position: relative;
  white-space: nowrap;
  & .vdp-datepicker__calendar {
    white-space: normal;
  }
  &__row {
    display: flex;
    align-items: center;
    &__title {
      width: 120px;
      font-size: 20px;
      font-weight: 700;
      margin-right: 18px;
    }
    &__item {
      display: flex;
      align-items: center;
      > span {
        margin-right: 8px;
      }
    }
    &__notify {
      margin-left: 1rem;
      font-weight: 700;
    }
  }
  .sameInsurerCheckbox {
    font-size: 13px;
  }
  .insurer_message {
    // 要保人 KYC風險屬性提示文字
    padding-left: 67px;
    color: #40ad0b;
    text-decoration: underline;
    text-underline-offset: 4px;
    cursor: pointer;
  }
  .insured_message {
    // 主約被保險人 FitBack健康吧提示文字
    padding-left: 180px;
    color: #40ad0b;
    text-decoration: underline;
    text-underline-offset: 4px;
    cursor: pointer;
  }
  .insured_message--disabled {
    color: #999;
    text-decoration: none;
    cursor: default;
    pointer-events: none;
  }
  .oldVersionBtn {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>
